var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: _vm.disableTransitions ? "" : "el-zoom-in-center" } },
    [
      _c(
        "span",
        {
          staticClass: "el-tag",
          class: [
            _vm.type ? "el-tag--" + _vm.type : "",
            _vm.tagSize && "el-tag--" + _vm.tagSize,
            { "is-hit": _vm.hit }
          ],
          style: { backgroundColor: _vm.color }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.closable
            ? _c("i", {
                staticClass: "el-tag__close uk-icon-close",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleClose($event)
                  }
                }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a5b0dc34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a5b0dc34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./packages/tag/src/tag.vue
// module id = 170
// module chunks = 0